module.exports = __webpack_public_path__ + "img/default-image.e04265f2.svg";